import {
  ApiGetRequest,
  EAibGrid,
  ECertificateDocumentType,
  EEecsRegistry,
  ETypeOfSupport,
  ICounterParty,
  IEnergyTypes,
} from 'types';

export enum EForwardModals {
  ADD_EDIT = 'add_edit',
  CONFIRM = 'confirm',
  DETAILS = 'details',
  EXCHANGE = 'exchange',
  FILL = 'fill',
}

export enum EForwardModalAction {
  ADD = 'add',
  EDIT = 'edit',
  DELETE = 'delete',
  CLONE = 'clone',
  REJECT = 'reject',
  APPROVE = 'approve',
}

export enum EForwardType {
  CREATED = 'created',
  ACQUIRED = 'acquired',
  SCHEDULED = 'scheduled',
}

export enum EForwardStatus {
  IN_PROGRESS = 'in_progress',
  NO_DELIVERY = 'no_delivery',
  NO_PAYMENT = 'no_payment',
  TERMINATED = 'terminated',
  FULFILLED = 'fulfilled',
  NO_CONFIRMATION = 'no_confirmation',
}

export interface IForwardDeliveryAssignment {
  id: number;
  volume: number;
  bundle_id: number;
}
export interface IForwardDelivery {
  id: number;
  volume: number;
  date: string;
  completed?: boolean;
  transaction_id?: string | null;
  assignment_list?: IForwardDeliveryAssignment[];
}

export interface IForwardShorten {
  id: number;
  rdid: string;
  energy_types: IEnergyTypes[];
  volume: number;
  delivery_started_at: string;
  delivery_completed_at: string;
  delivery_list: IForwardDelivery[];
  completed_deliveries: number | null;
  completed_delivery_volume: number | null;
  type: EForwardType;
  status: EForwardStatus;
  counter_party?: ICounterParty;
  reserved_volume: number | null;
  aib_grid_connected: EAibGrid;
  certifications: ECertificateDocumentType[] | null;
  country_of_issue_codes: string[] | null;
  production_period_start: string | null;
  production_period_end: string | null;
  operational_year_start: string | null;
  operational_year_end: string | null;
  type_of_support: ETypeOfSupport;
  production_device: number | null;
  production_device_name: string | null;
  production_device_id: string | null;
  _selected_volume?: number;
  buyer_incoming_registry: EEecsRegistry | null;
}

export interface IExchangeListingItem {
  id: number | null;
  internal_id: number;
  ids?: number[];
  price: number;
  volume: number;
}

export interface IForward extends IForwardShorten {
  on_exchange_quantity: number | null;
  exchange_list: IExchangeListingItem[];
  production_year: string;
  automatic_assignment: boolean | null;
  priority: number | null;
  price: number | null;
  recs_url: string | null;
  operational_date: string | null;
}

export interface ForwardModalPayload {
  action?: EForwardModalAction;
}

export interface IForwardModal {
  type: EForwardModals;
  payload?: ForwardModalPayload;
}

export interface FetchForwardsPayload extends ApiGetRequest {
  filter_by_has_exchanges?: boolean | null | number;
  filter_by_production_device_id?: string | null;
  filter_by_delivery_start_date?: string | null;
  filter_by_delivery_end_date?: string | null;
  filter_by_energy_source?: string | null;
  filter_by_type_of_installation?: string | null;
  filter_by_counter_party_necs_account_id?: string | null;
  filter_by_type?: string | null;
  filter_by_status?: string | null;
  filter_by_aib_grid_connected?: string | null;
  filter_by_type_of_support?: string | null;
  filter_by_production_date?: string | null;
  filter_by_operational_start_date?: number | null;
  filter_by_operational_end_date?: number | null;
  filter_by_issue_country?: string[] | null;

  order_by_production_device_name?: 'asc' | 'desc';
  order_by_volume?: 'asc' | 'desc';
  order_by_delivery_date?: 'asc' | 'desc';
  order_by_counter_party_company_name?: 'asc' | 'desc';
  order_by_type?: 'asc' | 'desc';
}

export interface AddForwardPayload {
  volume: number;
  forward_deliveries: IForwardDelivery[];
  aib_grid_connected: EAibGrid | string;
  type_of_support: ETypeOfSupport | string;
  production_year: string;
  energy_types: IEnergyTypes[];
  certifications: string[];
  country_of_issue_codes: string[];
  production_period_start: string | null;
  production_period_end: string | null;
  operational_year_start: string | null;
  operational_year_end: string | null;
}

export interface UpdateForwardPayload extends AddForwardPayload {
  id: number;
}

export interface UpdateForwardModePayload {
  id: number;
  auto: boolean;
  priority: number;
}

export interface CloneForwardPayload {
  id: number;
}

export interface DeleteForwardPayload {
  id: number;
}

export interface FetchForwardAssignBundlesPayload extends ApiGetRequest {
  delivery_id: number;
  filter_by_registry?: string | null;
}

export interface IForwardAssignBundle {
  id: number;
  bundle_id: number;
  volume: number;
  production_device_name: string;
}
export interface ForwardAssignBundlesResponse extends IForwardAssignBundle {}

export interface ForwardAssignBundlePayload {
  delivery_id: number;
  go_certificate_id: number;
  volume: number;
}

export interface DeleteForwardAssignmentPayload {
  delivery_id: number;
  assignment_id: number;
}
